import React from 'react';

export const DASH_COLORS = {
  gross: '#1d4ed8',
  net: '#3b82f6',
  fees: '#93c5fd',
  slate: '#475569',
  navy: '#1e3a8a',
};

export const compactMoney = (n) => {
  const v = Number(n || 0);
  if (Math.abs(v) >= 1e6) return `$${(v / 1e6).toFixed(2)}M`;
  if (Math.abs(v) >= 1e3) return `$${(v / 1e3).toFixed(Math.abs(v) >= 1e5 ? 0 : 1)}k`;
  return `$${v.toFixed(0)}`;
};

export const money = (n) =>
  `$${Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

/** Panel shell used across the dashboard — compact header, soft shadow, staggered rise-in. */
export const DashCard = ({ title, subtitle, icon: Icon, action, className = '', delay = 0, children, testid }) => (
  <section
    className={`dash-rise surface flex flex-col rounded-2xl ${className}`}
    style={{ animationDelay: `${delay}ms` }}
    data-testid={testid}
  >
    {(title || action) && (
      <header className="flex items-start justify-between gap-3 px-6 pt-6">
        <div className="min-w-0">
          <h3 className="flex items-center gap-2 text-base font-semibold text-slate-900 dark:text-white">
            {Icon && <Icon className="h-4 w-4 text-blue-600 dark:text-blue-400" />}
            {title}
          </h3>
          {subtitle && <p className="text-sm text-slate-600 dark:text-slate-300 mt-0.5">{subtitle}</p>}
        </div>
        {action}
      </header>
    )}
    <div className="flex-1 px-6 pb-6 pt-4">{children}</div>
  </section>
);

export const DashTooltip = ({ active, payload, label, labelFormatter, valueFormatter = money }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="rounded-xl bg-slate-900/95 text-white px-3 py-2 shadow-xl backdrop-blur text-sm border border-white/10">
      <div className="font-semibold mb-1 text-slate-200">{labelFormatter ? labelFormatter(label) : label}</div>
      {payload.map((p) => (
        <div key={p.dataKey || p.name} className="flex items-center gap-2 py-0.5">
          <span className="h-2 w-2 rounded-full" style={{ background: p.color || p.payload?.fill }} />
          <span className="text-slate-300">{p.name}</span>
          <span className="ml-auto font-mono pl-4">{valueFormatter(p.value)}</span>
        </div>
      ))}
    </div>
  );
};
